"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import classNames from "classnames";
import Account from "../../api/account";
import Api from "../../api/api";
import DisablingButton from "../../components/disabling_button";
import ExceptionItem from "./exception_item";
import { EmbeddedElmComponent } from "./embedded_elm_components";
import loadHelper from "../loads";
import NewException, { INVOICE_CONTEXT } from "./new_exception";
import ruleFormatter from "../../formatters/rules";
import CarrierService from "../../services/carrier_service";
import { isClickableException } from "../../helpers/exceptions_advance_pages";
import {
  CARRIER_INVOICE_MODEL_OBJECT_TYPE,
  FACTOR_INVOICE_MODEL_OBJECT_TYPE,
  LOAD_SHIPMENT_MODEL_OBJECT_TYPE
} from "../../api/exception_events";
import * as popout from "./../popout";
import UnapproveBanner from "./unapprove_banner";
import DOMPurify from "dompurify";
import { addIcon, aiIcon, errorAlertIcon, successAlertIcon } from "../ui/icons";
import { Notification } from "../ui/v3/notification";
import { Button, ButtonSize, ButtonVariant } from "../ui/v3/button";
import { Tooltip, TooltipDirection, TooltipLocation } from "../ui/v3/tooltip";
import * as Pb from "../data/types/Pb";
function ruleTooltip(metadata) {
  const tooltipText = formatMetadataForTooltip(metadata);
  return /* @__PURE__ */ jsx("span", { className: "enable_shared-ui-v3", children: /* @__PURE__ */ jsx("div", { className: "v3__theme", children: /* @__PURE__ */ jsx(
    Tooltip,
    {
      content: /* @__PURE__ */ jsx(
        "span",
        {
          style: {
            display: "inline-block",
            filter: "none",
            transition: "filter 0.2s ease"
          },
          onMouseEnter: (e) => {
            e.currentTarget.style.filter = "brightness(0)";
          },
          onMouseLeave: (e) => {
            e.currentTarget.style.filter = "none";
          },
          children: aiIcon()
        }
      ),
      tooltipContent: tooltipText,
      direction: TooltipDirection.Below,
      location: TooltipLocation.Hidden,
      tooltipContentStyle: {
        width: "auto",
        minWidth: "200px",
        maxWidth: "500px",
        whiteSpace: "pre-line"
      }
    }
  ) }) });
}
function possibleTooltipFor({ rule }) {
  if (Account.automateCustomExceptionMessages() && rule.rule_type === "plain_text_rule" && rule.data.results_metadata) {
    const hasMetadata = Object.keys(rule.data.results_metadata).length > 0;
    const hasFunctionResults = rule.data.results_metadata.function_results && Object.keys(rule.data.results_metadata.function_results).length > 0;
    if (hasMetadata && hasFunctionResults) {
      return ruleTooltip(rule.data.results_metadata);
    }
  }
  return null;
}
function isPodFailure(rule) {
  var _a;
  return rule.rule_type === "document_presence" && ((_a = rule.data) == null ? void 0 : _a.type) === "proofOfDelivery";
}
function openBillingReqsPopout(customerId) {
  popout.setCustomerId(customerId);
  popout.openOrFocusBillingReqsPopout();
}
function useBillingReqsPopout() {
  return Account.useBillingReqsPopout() && Account.hasRole("Broker");
}
function formatMetadataForTooltip(metadata) {
  const hasFailures = Object.values(metadata).some((value) => value === false);
  const headerText = hasFailures ? "Exception failed automation" : "Exception check automated";
  const functionMetadata = metadata.function_results || {};
  const description = metadata.description || "";
  const entries = Object.entries(functionMetadata).map(([key, value]) => {
    const readable = key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    const statusIcon = value ? /* @__PURE__ */ jsx(
      "span",
      {
        style: {
          marginRight: "4px",
          paddingBottom: "2px",
          display: "flex"
        },
        children: successAlertIcon()
      }
    ) : /* @__PURE__ */ jsx(
      "span",
      {
        style: {
          marginRight: "4px",
          paddingBottom: "2px",
          display: "flex"
        },
        children: errorAlertIcon()
      }
    );
    return /* @__PURE__ */ jsxs(
      "div",
      {
        style: { display: "flex", alignItems: "center", marginBottom: "2px" },
        children: [
          statusIcon,
          /* @__PURE__ */ jsx("span", { children: readable })
        ]
      },
      key
    );
  });
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        style: { fontWeight: "bold", marginBottom: "8px", minWidth: "300px" },
        children: headerText
      }
    ),
    /* @__PURE__ */ jsxs("div", { style: { marginBottom: "8px" }, children: [
      " ",
      description,
      " "
    ] }),
    /* @__PURE__ */ jsx("div", { children: entries })
  ] });
}
function isLoadShipmentApproved(props) {
  return modelObjectType(props) === LOAD_SHIPMENT_MODEL_OBJECT_TYPE && props.loadShipment.state === "Approved";
}
function isLoadShipmentBilled(props) {
  return modelObjectType(props) === LOAD_SHIPMENT_MODEL_OBJECT_TYPE && props.loadShipment.billed_in_tms;
}
function billedNotification(props) {
  if (isLoadShipmentBilled(props)) {
    return /* @__PURE__ */ jsxs("div", { className: "load-detail__shipment-final-header", children: [
      "No action needed. Status: ",
      props.loadShipment.shipment_status,
      "."
    ] });
  }
  if (isLoadShipmentApproved(props)) {
    return /* @__PURE__ */ jsx("div", { className: "load-detail__shipment-final-header", children: "No action needed. Status: Approved." });
  }
  return null;
}
function hasNoUnignoredExceptions(props) {
  return numExceptionsNotIgnored(props) === 0;
}
function emptyList(props) {
  if (props.v3ReskinEnabled) {
    return /* @__PURE__ */ jsx(Notification, { message: "No exceptions" });
  } else {
    return /* @__PURE__ */ jsx("li", { className: "rules__all-pass", children: "No Exceptions" });
  }
}
function numExceptions(props) {
  var _a;
  return failureMessages(props).length + ((_a = props.exceptionEvents) != null ? _a : []).length;
}
function numExceptionsNotIgnored(props) {
  var _a;
  const failures = failureMessages(props).filter((rule) => {
    return !loadHelper.ruleIsIgnored(modelObject(props), rule);
  });
  return failures.length + ((_a = props.exceptionEvents) != null ? _a : []).length;
}
function modelObject(props) {
  const objectLookup = {};
  objectLookup[LOAD_SHIPMENT_MODEL_OBJECT_TYPE] = props.loadShipment;
  objectLookup[CARRIER_INVOICE_MODEL_OBJECT_TYPE] = props.carrierInvoice;
  objectLookup[FACTOR_INVOICE_MODEL_OBJECT_TYPE] = props.factorInvoice;
  return objectLookup[modelObjectType(props)];
}
function modelObjectType(props) {
  if (props.loadShipment) {
    return LOAD_SHIPMENT_MODEL_OBJECT_TYPE;
  } else if (props.carrierInvoice) {
    return CARRIER_INVOICE_MODEL_OBJECT_TYPE;
  } else {
    return FACTOR_INVOICE_MODEL_OBJECT_TYPE;
  }
}
function failureMessages(props) {
  return modelObject(props) && modelObject(props).failure_messages || [];
}
function buildPodComponentFlags(props, overrides) {
  var _a;
  return {
    componentFlags: {
      type: Pb.EmbeddedComponentsFlags_ComponentFlagsType.PODDefinition,
      pod_definition: __spreadValues({
        display_text: "",
        unskippable: false,
        ignored: false,
        read_only: props.readOnly || false,
        carrier_invoice_id: (_a = props.carrierInvoice) == null ? void 0 : _a.id,
        rule_json: "",
        validation_error_messages: [],
        rule_failure_exists: false,
        ocr_drop_zone_class: "pod-definition__ocr-drop-zone",
        missing_pod_units: []
      }, overrides)
    }
  };
}
function maybeShowDefaultPodDefinitionComponent(props) {
  var _a;
  if (!Account.podDefinitionModuleEnabled()) {
    return null;
  }
  if (((_a = props.carrierInvoice) == null ? void 0 : _a.pod_requirement_skipped) === true) {
    return null;
  }
  if (failureMessages(props).some((r) => isPodFailure(r))) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: "rules__default-pod-definition", children: /* @__PURE__ */ jsx(
    EmbeddedElmComponent,
    {
      componentFlags: buildPodComponentFlags(props, {})
    }
  ) });
}
function showPodDefinitionComponentForRule(props, rule) {
  var _a, _b;
  const ignored = loadHelper.ruleIsIgnored(modelObject(props), rule);
  return /* @__PURE__ */ jsx(
    EmbeddedElmComponent,
    {
      componentFlags: buildPodComponentFlags(props, {
        display_text: rule.display_text,
        unskippable: ((_a = rule.data) == null ? void 0 : _a.unskippable) || false,
        ignored: !!ignored,
        carrier_invoice_id: props.carrierInvoice.id,
        rule_json: JSON.stringify(rule),
        validation_error_messages: ((_b = rule.data) == null ? void 0 : _b.validation_error_messages) || [],
        rule_failure_exists: true,
        missing_pod_units: rule.missing_pod_units || []
      })
    }
  );
}
function possibleAdditionalDetails(props, { rule }) {
  if (rule.display_text_details) {
    return rule.display_text_details.map(
      (item, index) => additionalDetail(props, item.text)
    );
  }
}
function possibleLoadNoteContext(props, { rule, load }) {
  if (load && load.data && rule && rule.rule_type === "note_on_load") {
    switch (rule.failure_type) {
      case "load_note":
        return additionalDetail(props, load.data.load_note);
      case "payables_note":
        return additionalDetail(props, load.data.payables_note);
    }
  }
}
function additionalDetail(props, note) {
  if (props.v3ReskinEnabled) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: "v3__type__small-body",
        style: { color: "var(--color-grayscale-600)" },
        children: note
      }
    );
  } else {
    return /* @__PURE__ */ jsx("span", { className: "rules__additional_details", children: note });
  }
}
function showAlert(props) {
  if (!hasNoUnignoredExceptions(props)) {
    if (props.v3ReskinEnabled) {
      const num = numExceptionsNotIgnored(props);
      const countClass = 0 <= num && num <= 9 ? "v3__badge-count--single-digit" : "";
      return /* @__PURE__ */ jsx("span", { className: "v3__badge v3__badge--alert v3__badge--size-default", children: /* @__PURE__ */ jsx("span", { className: `v3__badge-count ${countClass}`, children: num }) });
    } else {
      return /* @__PURE__ */ jsx("span", { className: "round alert label rules__header__alert", children: numExceptionsNotIgnored(props) });
    }
  }
}
function isLoading(state, rule) {
  return state.loading.indexOf(rule) >= 0;
}
function exceptionList(props) {
  var _a;
  return ((_a = props.exceptionEvents) != null ? _a : []).map(
    (exception) => showException(props, exception)
  );
}
function showException(props, exception) {
  return /* @__PURE__ */ jsx(
    ExceptionItem,
    {
      exception,
      exceptionResolver: props.exceptionResolver,
      owner: props.load,
      v3ReskinEnabled: props.v3ReskinEnabled
    }
  );
}
function billingRequirementsLink(props) {
  const loadShipment = props.loadShipment;
  let customerId;
  let showAlertIcon;
  let isHidden;
  if (Account.auditBillingEnabled()) {
    if (loadShipment && modelObjectType(props) === LOAD_SHIPMENT_MODEL_OBJECT_TYPE) {
      customerId = loadShipment.customer_id;
      showAlertIcon = loadShipment.customer_instructions && loadShipment.customer_instructions.length > 0;
    } else {
      isHidden = true;
    }
  } else {
    const tmsLoadShipments = props.load && props.load.load && props.load.load.tms_load_shipments || [];
    showAlertIcon = tmsLoadShipments.some(
      (shipment) => shipment.customer_instructions && shipment.customer_instructions.length > 0
    );
  }
  if (useBillingReqsPopout() && !isHidden) {
    const tooltipText = "Customer instructions are present";
    return /* @__PURE__ */ jsx("div", { className: "rules__header--details", children: /* @__PURE__ */ jsxs("a", { onClick: () => openBillingReqsPopout(customerId), children: [
      showAlertIcon && /* @__PURE__ */ jsxs("span", { className: "popup__wrapper", children: [
        /* @__PURE__ */ jsx("span", { className: "popup", children: tooltipText }),
        /* @__PURE__ */ jsx("span", { className: "icon-alert" })
      ] }),
      "Customer Details"
    ] }) });
  }
}
class RulesAndExceptions extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { loading: [] });
    __publicField(this, "renderV3Reskin", () => {
      const divider = /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            width: "100%",
            height: "1px",
            background: "var(--color-navy-400)"
          }
        }
      );
      const hasNoExceptions = numExceptions(this.props) === 0;
      const exceptions = () => {
        if (hasNoExceptions) {
          return emptyList(this.props);
        } else {
          const allExceptions = [this.ruleList(), exceptionList(this.props)].flat().map((row, i) => /* @__PURE__ */ jsx("div", { style: { margin: "0 var(--space-xs)" }, children: row }, `section-${i}`)).flatMap(
            (section, i) => i == 0 ? [section] : [React.cloneElement(divider, { key: `divider-${i}` }), section]
          );
          return /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "column",
                padding: "var(--space-xs) 0",
                gap: "var(--space-xs)",
                border: "1px solid var(--color-border-default)",
                borderRadius: "8px"
              },
              children: allExceptions
            }
          );
        }
      };
      return /* @__PURE__ */ jsxs(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "var(--space-xs)"
          },
          children: [
            /* @__PURE__ */ jsx("div", { style: { display: "flex", gap: "var(--space-xxs)" }, children: this.exceptionHeaderV3Reskin() }),
            this.newException(),
            /* @__PURE__ */ jsx(
              UnapproveBanner,
              {
                carrierInvoice: this.props.carrierInvoice,
                loadShipment: this.props.loadShipment,
                load: this.props.load,
                v3ReskinEnabled: true
              }
            ),
            exceptions(),
            maybeShowDefaultPodDefinitionComponent(this.props)
          ]
        }
      );
    });
    __publicField(this, "exceptionHeader", () => {
      if (modelObjectType(this.props) === LOAD_SHIPMENT_MODEL_OBJECT_TYPE) {
        const model = modelObject(this.props);
        if (model.customer_id != null && model.customer_name != null)
          return /* @__PURE__ */ jsxs("span", { children: [
            /* @__PURE__ */ jsxs("h3", { className: "rules__header--title", children: [
              model.customer_name,
              " (",
              model.shipment_external_id,
              ")",
              " ",
              showAlert(this.props),
              " ",
              this.addExceptionButton()
            ] }),
            billingRequirementsLink(this.props)
          ] });
        else
          return /* @__PURE__ */ jsxs("span", { children: [
            /* @__PURE__ */ jsxs("h3", { className: "rules__header--title", children: [
              "Missing Customer ",
              showAlert(this.props),
              " ",
              this.addExceptionButton()
            ] }),
            billingRequirementsLink(this.props)
          ] });
      } else if (Account.auditBillingEnabled()) {
        const maybeCarrier = CarrierService.getCarrierOrUnknown(
          this.props.carrierInvoice.carrier_id
        );
        const carrier_name = maybeCarrier ? maybeCarrier.name : "Error " + Account.carrierTerm() + " not found";
        return /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsxs("div", { className: "indexer-header__subject", children: [
            Account.carrierTerm(),
            " Exceptions"
          ] }),
          /* @__PURE__ */ jsxs("h3", { className: "rules__header--title", children: [
            carrier_name,
            " ",
            showAlert(this.props),
            " ",
            this.addExceptionButton()
          ] }),
          billingRequirementsLink(this.props)
        ] });
      } else
        return /* @__PURE__ */ jsxs("span", { children: [
          /* @__PURE__ */ jsxs("h3", { className: "rules__header--title", children: [
            "Exceptions ",
            showAlert(this.props),
            " ",
            this.addExceptionButton()
          ] }),
          billingRequirementsLink(this.props)
        ] });
    });
    __publicField(this, "exceptionHeaderV3Reskin", () => {
      const container = (els) => {
        return /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: "var(--space-xxxs)" }, children: [
          els,
          showAlert(this.props),
          this.addExceptionButton()
        ] });
      };
      if (modelObjectType(this.props) === LOAD_SHIPMENT_MODEL_OBJECT_TYPE) {
        const model = modelObject(this.props);
        if (model.customer_id != null && model.customer_name != null) {
          return container(
            /* @__PURE__ */ jsxs("span", { children: [
              model.customer_name,
              " (",
              model.shipment_external_id,
              ")"
            ] })
          );
        } else {
          return container(/* @__PURE__ */ jsx("span", { children: "Missing Customer" }));
        }
      } else if (Account.auditBillingEnabled()) {
        const maybeCarrier = CarrierService.getCarrierOrUnknown(
          this.props.carrierInvoice.carrier_id
        );
        const carrier_name = maybeCarrier ? maybeCarrier.name : "Error " + Account.carrierTerm() + " not found";
        return /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("h4", { children: Account.carrierTerm() }),
          container(carrier_name)
        ] });
      } else {
        return container(/* @__PURE__ */ jsx("h2", { children: "Exceptions" }));
      }
    });
    __publicField(this, "ruleList", () => {
      const rules = failureMessages(this.props);
      const sortedRules = rules.sort((a, b) => {
        const aIsAutomated = a.rule_type === "plain_text_rule" && a.data.results_metadata && Object.keys(a.data.results_metadata).length > 0;
        const bIsAutomated = b.rule_type === "plain_text_rule" && b.data.results_metadata && Object.keys(b.data.results_metadata).length > 0;
        if (aIsAutomated && !bIsAutomated) return 1;
        if (!aIsAutomated && bIsAutomated) return -1;
        return 0;
      });
      return sortedRules.map(this.showRuleFailure);
    });
    __publicField(this, "showRuleFailure", (rule) => {
      if (Account.podDefinitionModuleEnabled() && isPodFailure(rule)) {
        return showPodDefinitionComponentForRule(this.props, rule);
      }
      const ignored = loadHelper.ruleIsIgnored(modelObject(this.props), rule);
      const message = ruleFormatter.rule(rule);
      const sanitizedMessage = DOMPurify.sanitize(message, {
        USE_PROFILES: { html: true }
      });
      const load = this.props.load;
      const loadNoteContext = possibleLoadNoteContext(this.props, {
        rule,
        load: load && load.load
      });
      const additionalDetails = possibleAdditionalDetails(this.props, {
        rule
      });
      const possibleTooltip = possibleTooltipFor({ rule });
      if (this.props.v3ReskinEnabled) {
        const classes = classNames({
          v3__type__body: true,
          rules__ignored: ignored
        });
        return /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              display: "flex",
              gap: "24px",
              justifyContent: "space-between",
              alignItems: "flex-start"
            },
            onClick: () => {
              var _a, _b;
              return (_b = (_a = this.props).exceptionClicked) == null ? void 0 : _b.call(_a, rule);
            },
            children: [
              /* @__PURE__ */ jsxs(
                "div",
                {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    alignSelf: "center"
                  },
                  children: [
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        className: classes,
                        dangerouslySetInnerHTML: { __html: sanitizedMessage }
                      }
                    ),
                    loadNoteContext,
                    additionalDetails
                  ]
                }
              ),
              this.ruleButtonV3Reskin(rule, ignored)
            ]
          }
        );
      } else {
        const decoration = this.props.decorator(rule, sanitizedMessage);
        const classes = classNames({
          rules__ignored: ignored,
          "rules__item-text": true,
          rules__clickable: isClickableException(rule)
        });
        return /* @__PURE__ */ jsxs(
          "li",
          {
            className: "rules__item",
            onClick: () => {
              var _a, _b;
              return (_b = (_a = this.props).exceptionClicked) == null ? void 0 : _b.call(_a, rule);
            },
            children: [
              /* @__PURE__ */ jsx("span", { className: classes, children: /* @__PURE__ */ jsxs(
                "span",
                {
                  className: "text",
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    flexWrap: "wrap"
                    // Allow wrapping if needed
                  },
                  children: [
                    possibleTooltip,
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        dangerouslySetInnerHTML: { __html: sanitizedMessage }
                      }
                    ),
                    " ",
                    decoration,
                    loadNoteContext,
                    additionalDetails
                  ]
                }
              ) }),
              this.ruleButton(rule, ignored)
            ]
          }
        );
      }
    });
    __publicField(this, "ruleButton", (rule, ignored) => {
      if (rule.data.unskippable) {
        return /* @__PURE__ */ jsx(
          "button",
          {
            disabled: true,
            className: "rules__ignore-button rules__ignore-button--disabled",
            children: "Required"
          }
        );
      }
      if (!this.props.readOnly) {
        if (ignored) {
          return /* @__PURE__ */ jsx(
            DisablingButton,
            {
              onClick: (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.enableRule(rule);
              },
              disabled: isLoading(this.state, rule),
              disabledText: "Enabling...",
              disabledClassName: "rules__ignore-button rules__ignore-button--disabled",
              className: "rules__ignore-button",
              children: "Enable"
            }
          );
        }
        return /* @__PURE__ */ jsx(
          DisablingButton,
          {
            onClick: (event) => {
              event.preventDefault();
              event.stopPropagation();
              this.ignoreRule(rule);
            },
            disabled: isLoading(this.state, rule),
            disabledText: "Ignoring...",
            disabledClassName: "rules__ignore-button rules__ignore-button--disabled",
            className: "rules__ignore-button",
            children: "Ignore"
          }
        );
      }
    });
    __publicField(this, "ruleButtonV3Reskin", (rule, ignored) => {
      if (rule.data.unskippable) {
        return /* @__PURE__ */ jsx(
          Button,
          {
            size: ButtonSize.Medium,
            variant: ButtonVariant.Outlined,
            disabled: true,
            children: "Required"
          }
        );
      }
      if (!this.props.readOnly) {
        const ruleLoading = isLoading(this.state, rule);
        if (ignored) {
          return /* @__PURE__ */ jsx(
            Button,
            {
              size: ButtonSize.Medium,
              onClick: (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.enableRule(rule);
              },
              disabled: ruleLoading,
              variant: ButtonVariant.Outlined,
              children: ruleLoading ? "Enabling..." : "Enable"
            }
          );
        }
        return /* @__PURE__ */ jsx(
          Button,
          {
            size: ButtonSize.Medium,
            onClick: (event) => {
              event.preventDefault();
              event.stopPropagation();
              this.ignoreRule(rule);
            },
            disabled: ruleLoading,
            variant: ButtonVariant.Outlined,
            children: ruleLoading ? "Ignoring..." : "Ignore"
          }
        );
      }
    });
    __publicField(this, "startLoading", (rule) => {
      this.setState({ loading: this.state.loading.concat([rule]) });
    });
    __publicField(this, "doneLoading", (rule) => {
      return () => {
        this.setState({ loading: _.without(this.state.loading, rule) });
      };
    });
    __publicField(this, "enableRule", (rule) => {
      this.startLoading(rule);
      const done = this.doneLoading(rule);
      Api.Rules.enable(
        modelObject(this.props).id,
        rule,
        modelObjectType(this.props)
      ).then(done).catch(done);
    });
    __publicField(this, "ignoreRule", (rule) => {
      this.startLoading(rule);
      const done = this.doneLoading(rule);
      Api.Rules.ignore(
        modelObject(this.props).id,
        rule,
        modelObjectType(this.props)
      ).then(done).catch(done);
    });
    __publicField(this, "newException", () => {
      if (this.state.adding) {
        return /* @__PURE__ */ jsx(
          NewException,
          {
            context: INVOICE_CONTEXT,
            customExceptionOnly: true,
            exceptionCreator: this.createException,
            onCancel: this.cancelNewException,
            modelObjectType: modelObjectType(this.props),
            v3ReskinEnabled: this.props.v3ReskinEnabled
          }
        );
      }
    });
    __publicField(this, "createException", (message, ignore, types) => {
      return this.props.exceptionCreator(message, ignore, types).then(() => {
        this.setState({ adding: false });
      });
    });
    __publicField(this, "cancelNewException", () => {
      this.setState({ adding: false });
    });
    __publicField(this, "addExceptionButton", () => {
      if (isLoadShipmentApproved(this.props)) {
        return;
      }
      if (isLoadShipmentBilled(this.props)) {
        return;
      }
      if (this.state.adding) {
        return;
      }
      if (!this.props.exceptionCreator) {
        return;
      }
      if (this.props.readOnly) {
        return;
      }
      if (this.props.v3ReskinEnabled) {
        return /* @__PURE__ */ jsxs(
          Button,
          {
            size: ButtonSize.Small,
            variant: ButtonVariant.Text,
            style: { padding: 0 },
            onClick: () => {
              this.setState({ adding: true });
            },
            children: [
              addIcon(),
              /* @__PURE__ */ jsx("span", { children: "Add" })
            ]
          }
        );
      } else {
        return /* @__PURE__ */ jsx(
          "a",
          {
            onClick: () => {
              this.setState({ adding: true });
            },
            children: /* @__PURE__ */ jsx("i", { className: "fi-plus" })
          }
        );
      }
    });
  }
  render() {
    if (this.props.v3ReskinEnabled) {
      return this.renderV3Reskin();
    }
    const objectTypeName = `${modelObjectType(this.props)}-exception`;
    const hasNoExceptions = numExceptions(this.props) === 0;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        "data-component": "RulesAndExceptions",
        className: `load-detail__rules ${objectTypeName}`,
        children: [
          /* @__PURE__ */ jsx("div", { className: "rules__header", children: this.exceptionHeader() }),
          /* @__PURE__ */ jsx(
            UnapproveBanner,
            {
              carrierInvoice: this.props.carrierInvoice,
              loadShipment: this.props.loadShipment,
              load: this.props.load
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "rules__add-exception-container", children: this.newException() }),
          billedNotification(this.props),
          /* @__PURE__ */ jsx("ul", { className: "rules__list", children: hasNoExceptions ? emptyList(this.props) : [this.ruleList(), exceptionList(this.props)] }),
          maybeShowDefaultPodDefinitionComponent(this.props)
        ]
      }
    );
  }
}
__publicField(RulesAndExceptions, "defaultProps", {
  exceptionEvents: [],
  decorator: function() {
    return null;
  }
});
export default RulesAndExceptions;
